import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card, Container, Grid, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { fetchConToken } from "../../helpers/fetch";
import { fetchSubTipoEfectores } from "../../actions/tipoSubtipoEfectores";
import { startAlerta } from "../../actions/ui/alertas";
import { desSeleccionarContrato, setDataContrato } from "../../actions/contrataciones/contrataciones";

const fechaActual = new Date();

export const ContratacionesConsulta = (props) => {
  const dispatch = useDispatch();

  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );

  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
  }, []);

  useEffect(() => {
    let active = true;
    setLoading(true);

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      setLoading(false);
      return undefined;
    }

    (async () => {
        const response = await fetchConToken(`EfectorFacturacion/Busqueda?parametros=${inputValue}&todos=${props.todos ?? false}`)
        const results = await response.json();

          if (active) {
            let newOptions = [];
    
            if (value) {
              newOptions = [value];
            }
    
            newOptions = [...newOptions, ...results];
    
            setOptions(newOptions);
            setLoading(false);
          }
      
    })();
    return () => {
      active = false;
    };
  }, [value, inputValue]);

  const resetForm = () => {
    setOptions([]);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(desSeleccionarContrato());
    if (!value) {
      dispatch(startAlerta("Ingrese un Parametro.", "error"));
    } else {
      dispatch(setDataContrato(value));
      resetForm();
    }
  };

  useEffect(() => () => dispatch(desSeleccionarContrato()), []);

  return (
    <Grid item xs={12} sm={10} lg={8} xl={6}>
      <form onSubmit={submitHandler} style={{ marginTop: "2rem", marginBottom: "2rem" }}>
        <Grid
          container
          spacing={5}
          justify="center"
          alignItems="center"
          component={Card}
        >
          <Grid item xs={10}>
            <Container
              style={{
                padding: 3,
                marginTop: 5,
                margin: 5,
              }}
            >
            <Autocomplete
                filterOptions={(x) => x}
                options={options}
                autoComplete
                includeInputInList
                filterSelectedOptions
                value={value}
                onChange={(event, newValue) => {
                  setOptions(newValue ? [newValue, ...options] : options);
                  setValue(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                noOptionsText="No hay contrato"
                loadingText="Buscando..."
                loading={loading}
                getOptionLabel={(option) => {
                  const subTipoEfector = subtipoEfectores.find(
                    (subTipoEfector) =>
                      subTipoEfector.idSubTipoEfector ===
                      option.idSubTipoEfector
                  )?.descripcionSubTipoEfector;
                  return `${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`;
                }}
                renderOption={(option) => {
                  const subTipoEfector = subtipoEfectores.find(
                    (subTipoEfector) =>
                      subTipoEfector.idSubTipoEfector ===
                      option.idSubTipoEfector
                  )?.descripcionSubTipoEfector;
                  return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span
                        style={{
                          color: option.fechaBaja === null || option.fechaBaja >= fechaActual.toISOString() ? "green" : "red",
                        }}
                      >{`${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`}</span>
                    </div>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Cod contrato  |  CUIT  |  Razón Social  |  Nombre Fantasia"
                    fullWidth
                  />
                )}
              />
            </Container>
          </Grid>
          <Grid item xs={2}>
            <Button variant="contained" color="primary" fullWidth type="submit">
              CONTINUAR
            </Button>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};
